import script from "./ValidateCoupon.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidateCoupon.vue?vue&type=script&setup=true&lang=js"

import "./ValidateCoupon.vue?vue&type=style&index=0&id=3882f15e&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3882f15e"]])

export default __exports__